import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'breeze-intelligence-kit';
import { useCurrentUser } from 'policy-lib';
import { useEnrichmentCredits } from '../EnrichmentCreditsProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const UpgradeButton = props => {
  return /*#__PURE__*/_jsx(Button, Object.assign({}, props, {
    size: "sm",
    variant: "tertiary"
  }));
};
export const UsageUpgradeButton = () => {
  const {
    canUpgrade
  } = useEnrichmentCredits();
  const currentUser = useCurrentUser();
  const portalId = currentUser === null || currentUser === void 0 ? void 0 : currentUser.portalId;
  const breezeIntelligenceUrl = `/pricing/${portalId}/breeze-intelligence`;
  // const billingUrl = `/account-and-billing/${portalId}/usage/hubspot-credits`;

  if (canUpgrade) {
    return /*#__PURE__*/_jsx(UpgradeButton, {
      href: breezeIntelligenceUrl,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubSpotCredits.upgradeButton.buyCredits"
      })
    });
  }
  return /*#__PURE__*/_jsx(UpgradeButton, {
    href: breezeIntelligenceUrl,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubSpotCredits.upgradeButton.requestCredits"
    })
  });
};